// extracted by mini-css-extract-plugin
export default {"formItemMenu":"styles_formItemMenu__TQfBy","label":"styles_label__sNJGx","action":"styles_action__h1lV0","menuIcon":"styles_menuIcon__atTZq"};